import { Asset, Company, Loan, Note, Payment, Statement, TAssetId, TCompanyId, TLoanId } from '/src/lib/models';

export type PayoffEstimate = { payoffEstimate: number };

export enum PayoffType {
  Check = 'Check',
  Cash = 'Cash',
  Credit = 'Credit',
}

/**
 * List Payments
 */
export type TListPaymentsRequest = {
  loanId?: TLoanId;
  assetId?: TAssetId;
  lenderId?: TCompanyId;
  companyId?: TCompanyId;
};

export type TListPaymentsResponse = Payment[];

/**
 * Get Payment
 */
export type TGetPaymentResponse = Payment;

/**
 * Get Payoff Estimate Report
 */
export type TGetPayoffEstimateReportResponse = PayoffEstimate;

/**
 * Get Payoff Estimate
 */
export type TGetPayoffEstimateRequest = {
  loanId: TLoanId;
  asOfDate: Date;
};

export type TGetPayoffEstimateResponse = Statement;

/**
 * Create Payment
 */
export type CreatePaymentForm = {
  name: string;
  asset?: Asset;
  loan?: Loan;
  client?: Company;
  company?: Company;
  amount: number;
  paymentType: string;
  datePaid: string;
  dateDeposited?: string;
  effectiveDate: string;
  notes: Note[];
  files: string[];
};

export type TCreatePaymentRequest = {
  name: string;
  assetId: TAssetId;
  loan: TLoanId;
  client: TCompanyId;
  company: TCompanyId;
  amount: number;
  paymentType: string;
  datePaid: Date;
  dateDeposited: Date;
  effectiveDate: Date;
  notes: Note[];
  files: string[];
};

export type TCreatePaymentResponse = Payment;

/**
 * Update Payment
 */
export type UpdatePaymentForm = Payment;

export type TUpdatePaymentRequest = Payment;

export type TUpdatePaymentResponse = Payment;

/**
 * Delete Payment
 */
export type TDeletePaymentResponse = Payment;
